<div class="progress-wrapper">
  <!-- Label and percentage -->
  <div class="progress-header" *ngIf="label || showPercentage">
    <span class="progress-label" *ngIf="label">{{ label }}</span>
    <span class="progress-percentage" *ngIf="showPercentage && !indeterminate">{{ percentageText }}</span>
  </div>

  <!-- Progress bar container -->
  <div class="progress-container"
       [attr.data-size]="size"
       [attr.data-variant]="variant"
       [attr.data-indeterminate]="indeterminate"
       [attr.data-striped]="striped"
       [attr.data-animated]="animated"
       role="progressbar"
       [attr.aria-valuenow]="ariaValueNow"
       [attr.aria-valuemin]="0"
       [attr.aria-valuemax]="max"
       [attr.aria-label]="label || 'Progress'">
    
    <!-- Progress bar fill -->
    <div class="progress-bar"
         [style.width.%]="indeterminate ? 100 : percentage">
    </div>
  </div>
</div>